import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import { motion } from "framer-motion";  // <-- ADDED

function ModernProductsSection() {
  const products = [
    {
      img: "containimg_16.png",
      title: "TROMMEL SCREENING MACHINE",
      desc: "Miled steel EN-8 for pulley shafts.",
    },
    {
      img: "containimg_20.jpg",
      title: "GARBAGE SHREDDER WITH FEED CONVEYOR",
      desc: "Mild steel for structures OHNS/EN8 for pulley shafts.",
    },
    {
      img: "containimg_21.jpg",
      title: "NAPKIN INCINERATOR",
      desc: "Wall mounting – Capacity 10 to 50, Dimensions 250×250×450mm.",
    },
    {
      img: "containimg_22.jpg",
      title: "C & D Crushing Machine",
      desc: "Motor 15HP, 36 hammers, Capacity 800–1200 kg/hr.",
    },
    {
      img: "containimg_23.jpg",
      title: "CHICKEN WASTE CHOPPER model C33",
      desc: "Capacity 150–200 kg/hr, Alloy steel blades.",
    },
    {
      img: "containimg_40.jpg",
      title: "Bailing Machine",
      desc: "Pressure 15 Ton, Bale size 18×24 in, Weight 18–25kg.",
    },
    {
      img: "containimg_41.png",
      title: "CONVEYOR",
      desc: "Length 3600MM, Width 600MM, Height 900MM, custom geared motor.",
    },
  ];

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section
        className="mr_page_page_title page-title"
        style={{
          position: "relative",
          backgroundImage: `url('/equipment.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "320px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.45)",
          }}
        ></div>

        <div className="auto-container" style={{ position: "relative", zIndex: 2 }}>
          <h1
            className="mr_banner_title mr_xpage"
            style={{
              color: "#fff",
              fontSize: "48px",
              fontWeight: "700",
              textShadow: "0 3px 6px rgba(0,0,0,0.6)",
            }}
          >
            Products
          </h1>
        </div>
      </section>

      {/* PRODUCTS SECTION */}
      <section className="py-5 modern-section">
        <div className="container">
          <div className="row g-4">
            {products.map((item, index) => (
              <motion.div
                key={index}
                className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ scale: 1.03 }}
                style={{ cursor: "pointer" }}
              >
                <div className="modern-card fade-in">
                  <div className="img-wrapper">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="modern-img"
                    />
                  </div>

                  <div className="content text-center">
                    <h5 className="title">{item.title}</h5>
                    <p className="desc">{item.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default ModernProductsSection;
